import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import "./App.scss";
import requests from "./requests";
import LoadingAnimation from "./LoadingAnimation/LoadingAnimation";
import { WatchlistProvider } from "./utils/WatchlistContext";
import { NotificationProvider } from "./utils/NotificationContext";
import NotificationBanner from "./components/NotificationBanner/NotificationBanner";
import TestErrorBanner from "./utils/TestErrorBanner";
import ScrollToTop from "./utils/ScrollToTop";
import CacheDebug from "./components/CacheDebug";

const Nav = lazy(() => import("./Nav/Nav"));
const Banner = lazy(() => import("./Banner/Banner"));
const Row = lazy(() => import("./Row/Row"));
const Footer = lazy(() => import("./Footer/Footer"));
const MyList = lazy(() => import("./MyList/MyList"));
const Podcast = lazy(() => import("./Podcast/Podcast"));
const Author = lazy(() => import("./Author/Author"));
const Search = lazy(() => import("./Search/Search"));

function App() {
  const [dynamicColor] = React.useState('rgba(0, 114, 210, 0.03)');

  return (
    <Router>
      <ScrollToTop />
      <NotificationProvider>
        <WatchlistProvider>
          <div className="app" style={{ '--dynamic-color': dynamicColor }}>
            <Suspense fallback={<LoadingAnimation />}>
              <Nav />
              <Switch>
                <Route exact path="/">
                  <Banner fetchUrl={requests.fetchRandom} />
                  <Row title="Najnowsze" fetchUrl={requests.fetchLatest} isLargeRow />
                  <Row
                    title="Odcinki Specjalne"
                    fetchUrl={requests.fetchSpecial}
                    isLargeRow
                  />
                  <Row title="Wszystkie Odcinki" fetchUrl={requests.fetchAllChannelVideos} />
                </Route>
                <Route path="/my-list">
                  <MyList />
                </Route>
                <Route path="/podcast">
                  <Podcast />
                </Route>
                <Route path="/author">
                  <Author />
                </Route>
                <Route path="/search">
                  <Search />
                </Route>
                <Route path="/test-error">
                  <TestErrorBanner />
                </Route>
              </Switch>
              <Footer></Footer>
            </Suspense>
            <NotificationBanner />
            <CacheDebug />
          </div>
        </WatchlistProvider>
      </NotificationProvider>
    </Router>
  );
}

export default App;
